import { ReducerState } from "../../../state/reducers/types"
import { addOrUpdate, remove } from "../../../state/reducers/utils"
import { ActionType, DeliveriesAction } from './actionTypes'
import { Delivery, DeliveryOrder } from "./types"

export type DeliveriesState = {
    deliveryOrders: DeliveryOrder[]
    deliveries: Delivery[]
}

const initialState: DeliveriesState = {
    deliveryOrders: [],
    deliveries: [],
}

const reducer = (state = initialState, action: DeliveriesAction) => {
    switch(action.type) {
        case ActionType.UPDATE_DELIVERY_ORDERS:
            return { 
                ...state,
                deliveryOrders: addOrUpdate(state, action, 'deliveryOrders' as keyof ReducerState)
            }
        case ActionType.REMOVE_DELIVERY_ORDERS:
            return { 
                ...state,
                deliveryOrders: remove(state, action, 'deliveryOrders' as keyof ReducerState)
            }
        case ActionType.UPDATE_DELIVERIES:
            return { 
                ...state,
                deliveries: addOrUpdate(state, action, 'deliveries' as keyof ReducerState)
            }
        case ActionType.REMOVE_DELIVERIES:
            return { 
                ...state,
                deliveries: remove(state, action, 'deliveries' as keyof ReducerState)
            }
        default:
            return state
    }
}

export default reducer
